<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div
  class="record-icon-text"
  fxLayout="row"
  [ngStyle]="{ color: componentColor }"
>
  <div class="record-icon" fxLayoutAlign="center center">
    <fa-icon [icon]="icon"></fa-icon>
  </div>
  <div id="record-text" class="preserve-newlines" [ngClass]="{ 'link': linkType !== undefined }" (click)="onClick()">
    {{ text }}
  </div>
</div>
